"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.107 13.33A7.965 7.965 0 0 0 8 15.95c4.383 0 7.949-3.566 7.949-7.95S12.384.05 8 .05C3.618.05.05 3.616.05 8a7.93 7.93 0 0 0 1.089 4.011L2 11.505A6.93 6.93 0 0 1 1.05 8 6.957 6.957 0 0 1 8 1.05 6.957 6.957 0 0 1 14.95 8 6.958 6.958 0 0 1 8 14.95a6.964 6.964 0 0 1-5.152-2.292l-.741.671Zm3.262-2.606.488.873s4.888-2.733 5.34-2.983c.193-.107.457-.252.461-.584.004-.338-.248-.484-.554-.662-.418-.243-4.476-2.583-4.868-2.81-.256-.148-.52-.302-.815-.13-.292.17-.29.472-.287.738V9.46h1V5.655c.931.536 3.125 1.802 4.086 2.358l-4.85 2.71Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M3.023 19.91a11.972 11.972 0 0 0 8.978 4.063c6.594 0 11.96-5.366 11.96-11.962S18.596.048 12.002.048C5.404.048.038 5.415.038 12.011c0 2.122.566 4.21 1.637 6.035l.97-.57a10.81 10.81 0 0 1-1.482-5.465c0-5.976 4.862-10.838 10.838-10.838 5.974 0 10.836 4.862 10.836 10.838 0 5.976-4.862 10.837-10.836 10.837a10.847 10.847 0 0 1-8.133-3.682l-.845.744Zm5.05-3.555.549.982 8.049-4.498.122-.067h.002c.292-.162.594-.328.6-.718.005-.397-.298-.574-.743-.834l-.006-.003c-.462-.268-3.838-2.216-5.898-3.404L9.199 6.92l-.005-.002c-.386-.223-.692-.399-1.039-.196-.345.2-.342.565-.338.95v6.573h1.126V8.07l1.242.717a6971.51 6971.51 0 0 1 5.623 3.244l-7.735 4.323Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.031 26.547a15.963 15.963 0 0 0 11.97 5.418c8.793 0 15.948-7.155 15.948-15.95 0-8.796-7.155-15.95-15.948-15.95C7.206.064.051 7.218.051 16.014c0 2.83.755 5.613 2.182 8.046l1.294-.759a14.413 14.413 0 0 1-1.976-7.287c0-7.969 6.482-14.45 14.45-14.45 7.966 0 14.448 6.481 14.448 14.45 0 7.968-6.482 14.45-14.448 14.45-4.143 0-8.095-1.79-10.844-4.91l-1.126.992Zm6.734-4.74.73 1.31 10.733-5.998.163-.09h.003c.39-.215.792-.436.799-.957.007-.53-.396-.765-.99-1.111l-.008-.005c-.615-.357-5.117-2.954-7.864-4.538l-2.065-1.192-.006-.004c-.515-.296-.924-.531-1.386-.261-.46.268-.456.754-.451 1.268v8.763h1.5V10.76l1.658.956c2.392 1.379 6.116 3.527 7.497 4.326l-10.313 5.764Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.39 39.139C9.979 44.769 16.761 48 24 48c13.232 0 23.997-10.766 23.997-24S37.232 0 24 0C10.766 0 0 10.766 0 24c0 4.26 1.135 8.446 3.284 12.107l1.617-.949A22.07 22.07 0 0 1 1.875 24C1.875 11.8 11.8 1.875 24 1.875 36.198 1.875 46.122 11.8 46.122 24S36.198 46.125 24 46.125c-6.672 0-12.925-2.978-17.156-8.171l-1.455 1.185Zm10.762-6.175.915 1.637s15.134-8.46 16.283-9.1l.248-.136h.001c.568-.312 1.104-.606 1.112-1.28.01-.69-.507-.99-1.288-1.444l-.127-.073c-.8-.466-5.939-3.43-10.014-5.781l-1.896-1.094-3.154-1.82c-.759-.437-1.307-.753-1.91-.402-.598.348-.592.967-.586 1.75l.003 13.296h1.875V15.681l2.835 1.637.022.012c3.905 2.253 10.105 5.828 11.638 6.717a68761.03 68761.03 0 0 0-15.957 8.917Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M7.186 52.185C13.305 59.693 22.35 64 32 64c17.643 0 31.996-14.355 31.996-32S49.643 0 32 0C14.355 0 0 14.355 0 32a31.927 31.927 0 0 0 4.378 16.143l2.157-1.265A29.427 29.427 0 0 1 2.5 32C2.5 15.734 15.734 2.5 32 2.5c16.264 0 29.496 13.234 29.496 29.5S48.264 61.5 32 61.5c-8.896 0-17.233-3.971-22.875-10.895l-1.939 1.58Zm14.35-8.233 1.22 2.183s20.179-11.28 21.71-12.134l.33-.18.003-.002c.757-.416 1.472-.808 1.483-1.707.012-.919-.676-1.319-1.718-1.924l-.17-.098c-1.065-.62-7.91-4.569-13.343-7.703l-2.536-1.463-4.206-2.426c-1.011-.584-1.742-1.005-2.546-.537-.797.464-.79 1.29-.781 2.333l.003 17.73h2.5V20.907l3.78 2.182.038.021c5.207 3.004 13.466 7.767 15.509 8.951a87913.98 87913.98 0 0 0-21.276 11.89Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconVideo = function IconVideo(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Video' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "Video"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconVideo.sizes = [16, 24, 32, 48, 64];
IconVideo.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconVideo;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/Video.js
// module id = 1879
// module chunks = 0